function minutes(t) {
  return Math.floor(t / 60)
}

function seconds(t) {
  return Math.floor(t % 60)
}

export function secondsToString(t) {
  if (t < 0) {
    return '00:00'
  } else {
    return [minutes, seconds]
      .map(fn => fn(t))
      .map(n => n.toString().padStart(2, '0'))
      .join(':')
  }
}

export function secondsToFullString(t) {
  const m = minutes(t)
    ? `${minutes(t)} minute${minutes(t) !== 1 ? 's' : ''}`
    : null
  const s = `${seconds(t)} second${seconds(t) !== 1 ? 's' : ''}`

  return m ? [m, s].join(', ') : s
}
